import CarItem from '../../helperTypes/CarItem';
import PricingRequestDriver from '../subEntities/PricingRequestDriver';
import PricingRequestUnitData from '../subEntities/PricingRequestUnitData';

/**
 * Returns a Unit instance compatible with the request implementation
 *
 * @param car - The source car
 * @param requestDriver - The generated request driver
 */
export default function makeRequestUnitData(
  car: CarItem,
  requestDriver: PricingRequestDriver,
): PricingRequestUnitData {
  return {
    /** General car information */
    BrandId: car.brand,
    ModelId: car.model.id,
    ModelYear: car.year,
    value: car.value.toString(),
    driver: requestDriver,
    Category: car.category,
    Cylinder: car.cylinder,
    Fuel: car.fuel,
    HasBill: car.hasBill,
    LicensePlate:
      car.category === 'CARGA LIVIANA'
        ? `CL${car.licensePlate}`
        : car.licensePlate,
    PassengersQty: car.passengersQty,
    SerialChassis: car.serialChassis,
    SerialMotor: car.serialMotor,
    TreasuryValue: car.treasuryValue,
    TypeOfMoney: car.typeOfMoney,
    Use: car.use,

    /** The only value that is actually calculated */
    isNewCar: typeof car.isNewCar !== 'undefined' ? car.isNewCar : false,

    /** Hard coded values */
    Type: 'A',
    Weight: '000',
    Color: car.color,
  };
}
